module.exports = __webpack_public_path__ + "static/media/sorrento-8.31d53a9b.jpg";